import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RegexUtil } from 'src/app/helpers/regex.helper';
import { IClientInfo } from './../../../../model/client-info.interface';
import { SharedDataService } from './../../../../service/shared-data.service';
import { getErrorCodeFromError } from './initiate-login.model';

@Component({
  selector: 'app-initiate-login',
  templateUrl: './initiate-login.component.html',
  styleUrls: ['./initiate-login.component.scss'],
})
export class InitiateLoginComponent implements OnInit {
  displayName: string = '';
  gloTypeRegister: string = '';
  shopSource: string = '';
  isClassicalLoginEnabled: boolean = false;
  isRememberMe: boolean = false;
  isAllowGuestLogin: boolean = false;
  socialLoginProviders: string[] = [];
  customProviders: any[] = [];
  samlProviders: any[] = [];
  AD_Providers: any[] = [];
  errorMsg: any;
  userHint: any;
  requestId: any;
  inviteId: any;
  Allow_Login_With: any[] = [];
  errorCodes = ['invalid_grant', 'access_denied'];
  usernameType: any;
  linkId: any;
  translationStatus$ = this._dataService._getTranslationLoadStatus();
  private clientInfo: Subscription = new Subscription();

  constructor(
    private _dataService: SharedDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _regex: RegexUtil
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.errorMsg = params.error && getErrorCodeFromError(params.error);
      this.userHint = params.username;
      this.requestId = params.requestId;
      this.inviteId = params.inviteId;
      this.linkId = params.linkId;
      this.shopSource = params.shop_source;
      this.gloTypeRegister = params.gloTypeRegister ? params.gloTypeRegister : '';
    });

    this._init();
  }

  // initializing method
  _init = () => {
    this.clientInfo = this._dataService._getClientInfo().subscribe((data: IClientInfo) => {
      if (data && Object.keys(data).length) {
        this._enableRegistration(data);
        this._getDisplayName(data);
        this._getSocialLoginProviders(data);
        this._getIsRememberMeSelected(data);
        this._getCustomProviders(data);
        this._getSAMLProviders(data);
        this._getActiveDirectoryProviders(data);
        this.getIsAllowedGuestLogin(data);
        this._getAllowLoginTypes(data);
      }
    });
  };

  // get  allow login types
  _getAllowLoginTypes = (data: Pick<IClientInfo, 'allow_login_with'>) => {
    this.Allow_Login_With = data.allow_login_with ? data.allow_login_with : [];
    this.isClassicalLoginEnabled = this.Allow_Login_With.length > 0;
    this._checkLoginError();
  };

  // check if login user has error  user name or password is wrong
  _checkLoginError() {
    if (this.errorMsg && !this.errorCodes.includes(this.errorMsg)) {
      if (this.userHint) {
        let usernameType = this._checkValueType(this.userHint);
        if (this.linkId) {
          this.router.navigate(['initiate'], {
            relativeTo: this.activatedRoute,
            queryParams: {
              userIdHint: this.userHint,
              requestId: this.requestId,
              error: this.errorMsg,
              type: usernameType,
              'linkId': this.linkId,
            },
          });
        } else {
          this.router.navigate(['initiate'], {
            relativeTo: this.activatedRoute,
            queryParams: {
              userIdHint: this.userHint,
              requestId: this.requestId,
              error: this.errorMsg,
              type: usernameType,
            },
          });
        }
      }
    }
  }
  // set display name
  _getDisplayName = (data: Pick<IClientInfo, 'client_display_name'>) => {
    this.displayName = data.client_display_name ? data.client_display_name : '';
  };

  // get social login providers
  _getSocialLoginProviders = (data: Pick<IClientInfo, 'login_providers'>) => {
    this.socialLoginProviders = data.login_providers ? data.login_providers : [];
  };

  // get custom providers
  _getCustomProviders = (data: Pick<IClientInfo, 'custom_providers'>) => {
    this.customProviders = data.custom_providers ? data.custom_providers : [];
  };

  // set remember me
  _getIsRememberMeSelected = (data: Pick<IClientInfo, 'is_remember_me_selected'>) => {
    this.isRememberMe = data.is_remember_me_selected ? data.is_remember_me_selected : false;
  };

  // get saml providers
  _getSAMLProviders = (data: Pick<IClientInfo, 'saml_providers'>) => {
    this.samlProviders = data.saml_providers ? data.saml_providers : [];
  };

  // get AD providers
  _getActiveDirectoryProviders = (data: Pick<IClientInfo, 'ad_providers'>) => {
    this.AD_Providers = data.ad_providers ? data.ad_providers : [];
  };

  //check if guest login enabled
  getIsAllowedGuestLogin(data: Pick<IClientInfo, 'allow_guest_login'>) {
    this.isAllowGuestLogin = data.allow_guest_login ? data.allow_guest_login : false;
  }

  _checkValueType = (value: string) => {
    let mobileRegx = this._regex.mobile;
    let emailRegx = this._regex.email;
    if (mobileRegx.test(value) && this.Allow_Login_With.includes('MOBILE')) {
      return 'mobile';
    }
    if (emailRegx.test(value) && this.Allow_Login_With.includes('EMAIL')) {
      return 'email';
    }
    if (value && this.Allow_Login_With.includes('USER_NAME')) {
      return 'username';
    }
    return '';
  };

  _enableRegistration = (data: any): void => {
    if (data?.registration_enabled) {
      this._dataService.isRegistrationEnabled = data?.registration_enabled;
    } else if (data?.invite_enabled && this.inviteId) {
      this._dataService.isRegistrationEnabled = true;
    } else {
      this._dataService.isRegistrationEnabled = false;
    }
  };

  ngOnDestroy() {
    this.clientInfo.unsubscribe();
  }
}
